import { render, staticRenderFns } from "./EntityHeaderV2.vue?vue&type=template&id=2ed53709&scoped=true&"
import script from "./EntityHeaderV2.vue?vue&type=script&lang=js&"
export * from "./EntityHeaderV2.vue?vue&type=script&lang=js&"
import style0 from "./EntityHeaderV2.vue?vue&type=style&index=0&id=2ed53709&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed53709",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed53709')) {
      api.createRecord('2ed53709', component.options)
    } else {
      api.reload('2ed53709', component.options)
    }
    module.hot.accept("./EntityHeaderV2.vue?vue&type=template&id=2ed53709&scoped=true&", function () {
      api.rerender('2ed53709', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/EntityHeaderV2.vue"
export default component.exports